// extracted by mini-css-extract-plugin
module.exports = {"base":"bs-lp20-src-components-anchor-module-base"};